import axios from '@axios'
import config from '@core/app-config/api-config'

const base = `${config.host}/frontend-routing`

/** Admin API of the edge router's rules; the backend accepts admins only and records who made each change. */
const frontendRoutingApi = {
  getState() {
    return axios.get(base)
  },
  createRule(payload) {
    return axios.post(`${base}/rules`, payload)
  },
  updateRule(id, payload) {
    return axios.patch(`${base}/rules/${id}`, payload)
  },
  deleteRule(id) {
    return axios.delete(`${base}/rules/${id}`)
  },
  setKillSwitch(killSwitch) {
    return axios.put(`${base}/kill-switch`, { killSwitch })
  },
  /** «Автозащита»: whether the edge router's watchdog may switch the kill switch on by itself */
  setWatchdog(watchdog) {
    return axios.put(`${base}/watchdog`, { watchdog })
  },
}

export default frontendRoutingApi
